<ng-container *ngIf="dataKUL$ | async as dataKul; else loaderTpl">
  <div class="button-group d-flex flex-nowrap align-items-center mb-10">
    <button class="ms-auto btn btn-outline btn-transparent px-8" type="button" mat-button color="primary" (click)="onPrint()">
      <span class="svg-icon svg-icon-24 me-2" inlineSVG="{{ STRING_CONSTANTS.ICON.IC_PRINT }}"></span>
      <span>Print</span>
    </button>
    <button class="btn btn-outline btn-transparent px-8 ms-lg-2" type="button" mat-button color="primary" (click)="onCancel()">
      <span>Batal</span>
    </button>
  </div>
  <div #printSectionRef class="{{ browser }}" id="print-section" ngxPrintElement>
    <div class="page">
      <div class="header">
        <img alt="" class="img-header" src="{{ imgHeader }}" />
        <div class="space-10"></div>
        <div class="campton-medium font-10 medium text-right mr-4">No Langganan : {{ dataKul.subs_number }}</div>
        <div class="space-20"></div>
        <div class="campton font-18 bold text-center mb-3">KONDISI UNTUK LANGGANAN (KUL)</div>
        <div class="campton-medium font-14 medium text-center mb-3">PT MAXXI AGRI INDONESIA</div>
        <div class="campton-medium font-12 medium text-center mb-4">No. {{ dataKul.number }}</div>
        <div class="d-flex justify-center">
          <div class="form-check mb-4 d-flex align-center">
            <input [checked]="dataKul.is_credit" class="form-check-input mr-2" type="checkbox" />
            <label class="campton-medium form-check-label font-10 mr-70 medium">Kredit</label>
          </div>
          <div class="form-check mb-4 d-flex align-center">
            <input [checked]="dataKul.is_cash" class="form-check-input mr-2" type="checkbox" />
            <label class="campton-medium form-check-label font-10 medium">Tunai</label>
          </div>
        </div>
      </div>
      <div class="space-20"></div>
      <div class="body">
        <table>
          <tr>
            <td class="font-12 bold">1.</td>
            <td class="font-12 bold">Nama</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Pelanggan</div>
              <span class="font-9">(perorangan/badan usaha)</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.business_name }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Pemilik</div>
              <span class="font-9">(perorangan badan usahayang bukan badan hukum)</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.owner_name }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Pemimpin/Pengurus/Pemegang Usaha</div>
              <span class="font-9">(selanjutnya disebut pembeli)</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.manager_name }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">2.</td>
            <td class="font-12 bold">Alamat</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Pelanggan</div>
              <span class="font-9">(perorangan/badan usaha)</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.business_address }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Telp./HP</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.business_phone_number }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Email</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.business_email }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Pemilik</div>
              <span class="font-9">(tempat tinggal terahir)</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.owner_address }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Telp./HP</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.owner_phone_number }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Email</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.owner_email }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Pemimpin/Pengurus/Pemegang Usaha</div>
            </td>
            <td class="font-10 medium">: {{ dataKul.manager_address }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Telp./HP</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.manager_phone_number }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Email</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.manager_email }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <div class="font-10 bold">Penagihan</div>
            </td>
            <td class="font-10 medium">: {{ dataKul.billing_address }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Telp./HP</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.billing_phone_number }}</td>
          </tr>
          <tr>
            <td></td>
            <td class="w-30">
              <span class="font-9">Email</span>
            </td>
            <td class="font-10 medium">: {{ dataKul.billing_email }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">3.</td>
            <td>
              <div class="font-10 bold">NPWP Pembeli</div>
            </td>
            <td class="font-10 medium">: {{ dataKul.npwp }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">4.</td>
            <td>
              <div class="font-10 bold">Jangka Waktu Kredit</div>
            </td>
            <td class="font-10 medium">: {{ handleDataNull(dataKul.credit_term) }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">5.</td>
            <td>
              <div class="font-10 bold">Plafon Kredit</div>
            </td>
            <td class="font-10 medium">: {{ handleCredit(dataKul.credit_ceiling) }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">6.</td>
            <td>
              <div class="font-10 bold">Jaminan</div>
            </td>
            <td class="font-10 medium">: {{ handleDataNull(dataKul.assurance) }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">7.</td>
            <td>
              <div class="font-10 bold">Domisili Hukum</div>
            </td>
            <td class="font-10 medium">
              : Apabila pada kemudian hari terjadi sengketa antara Penjual dan Pembeli, Penjual dan Pembeli dengan ini sepakat untuk pada waktunya nanti memilih domisili hukum yang
              bersama di Pengadilan Negeri Surabaya.
            </td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">8.</td>
            <td>
              <div class="font-10 bold">Affiliasi Usaha & Kekerabatan</div>
            </td>
            <td class="font-10 medium">: {{ handleDataNull(dataKul.affiliation) }}</td>
          </tr>
          <tr class="space-5"></tr>
          <tr>
            <td class="font-12 bold">9.</td>
            <td>
              <div class="font-10 bold">Lain-Lain</div>
            </td>
            <td class="font-10 medium">: {{ handleDataNull(dataKul.other) }}</td>
          </tr>
        </table>
      </div>
      <div class="footer"></div>
    </div>
    <div class="page">
      <div class="header">
        <img alt="" class="img-header mb-8" src="{{ imgHeader }}" />
        <div class="space-20"></div>
        <div class="campton font-18 bold text-center">PERSYARATAN DAN KETENTUAN UMUM JUAL BELI</div>
        <div class="space-20"></div>
      </div>
      <div class="body">
        <p class="font-10 medium">
          Persyaratan-persyaratan dan ketentuan-ketentuan sebagaimana diuraikan dibawah ini merupakan bagian yang tidak terpisahkan dari KUL, dengan ketentuan: istilah
          <b>“PEMBELI”</b> merujuk kepada Pelanggan, baik perorangan maupun badan usaha, termasuk tetapi tidak terbatas pada
          <b>pemilik usaha, pimpinan, pemegang/penerima kuasa</b> yang mewakili Pelanggan untuk menandatangani KUL atau melakukan transaksi berdasarkan KUL, termasuk tetapi tidak
          terbatas pada <b>pihak-pihak yang tergabung dalam suatu grup usaha dari Pelanggan.</b>
        </p>
        <ol>
          <li class="font-10 medium">
            Jika pembayaran harga atas barang yang diperjualbelikan (“Objek Jual Beli”) dilakukan melalui giro harus atas nama perusahaan dan/atau transfer bank harus ke rekening
            atas nama perusahaan ( sesuai dengan informasi di Faktur ) , maka pembayaran dianggap terjadi pada saat kliring atau proses di bank diselesaikan dan uang tersebut telah
            diterima oleh PENJUAL pada rekening yang ditetapkan dan jumlahnya sesuai dengan yang diperjanjikan.
          </li>

          <li class="font-10 medium">
            Jika terjadi keterlambatan pembayaran atau pembayaran melewati jangka waktu kredit sebagaimana diatur dalam KUL, maka PENJUAL dapat mengenakan sanksi menurut ketentuan
            yang ditetapkan oleh PENJUAL.
          </li>

          <li class="font-10 medium">
            Jika terjadi perubahan persyaratan dan ketentuan dalam KUL, maka dokumen-dokumen dan/atau korespondensi yang berhubungan dengan perubahan tersebut merupakan
            satu-kesatuan dan bagian yang tidak terpisahkan dari KUL ini.
          </li>

          <li class="font-10 medium">
            Jika terdapat kewajiban pembayaran Objek Jual Beli yang terutang, maka PENJUAL dapat meminta PEMBELI untuk memberikan jaminan, apabila belum ada, atas kewajiban
            pembayaran yang terutang.
          </li>

          <li class="font-10 medium">
            Bahwa penyerahan data pribadi dan data apapun yang dianggap penting demi kelancaran dan kemudahan untuk proses administrasi KUL telah mendapatkan izin dari pihak –
            pihak yang melakukan perikatan dan akan di jamin keamanan data diri tersebut.
          </li>

          <li class="font-10 medium">
            Tanpa mengurangi ketentuan butir (3) diatas, segala dokumen dan atau lampiran yang dibuat sehubungan dengan KUL ini merupakan satu kesatuan dan bagian yang tidak
            terpisahkan dari KUL ini.
          </li>
        </ol>
        <div class="space-10"></div>
        <div class="d-flex justify-center">
          <p>______________,_______________________________</p>
        </div>
        <div class="space-10"></div>
        <div class="d-flex justify-evenly">
          <div class="pembeli text-center">
            <p class="bold font-10">Pembeli</p>
            <div class="space-20"></div>
            <p class="medium font-8">Materai & Cap</p>
            <div class="space-20"></div>
            <div class="mb--4 font-10">{{ dataKul.owner_name.toUpperCase() }}</div>
            <p class="mb-0 medium font-10">(______________________________)</p>
            <p class="medium font-10">Tanda Tangan & Stempel</p>
          </div>
          <div class="penjual text-center">
            <p class="bold font-10 text-center">Penjual<br />PT MAXXI AGRI INDONESIA</p>
            <div class="space-50"></div>
            <div class="space-1"></div>
            <p class="mb-0 medium font-10">(______________________________)</p>
          </div>
        </div>
        <div class="space-20"></div>
        <div class="lampiran">
          <p class="font-9 bold mb-2">Lampiran-lampiran :</p>
          <p class="font-9 bold mb-2">Untuk Pelanggan Perorangan atau Badan Usaha bukan Badan Hukum (Firma, CV, UD)</p>
          <ul class="mb-6">
            <li class="font-9 medium">Fotokopi KTP Pelanggan atau penandatangan KUL dan/atau pimpinan.</li>
            <li class="font-9 medium">Fotokopi NPWP Pelanggan (perlu diminta ulang apabila ada perubahan nama/alamat).</li>
            <li class="font-9 medium">Surat kuasa, jika penandatangan KUL diwakilkan.</li>
            <li class="font-9 medium">Surat pernyataan tidak ber-NPWP, jika pelanggan tidak ber-NPWP.</li>
            <li class="font-9 medium">Surat pernyataan penanggungan jika ada point No. 8.</li>
            <li class="font-9 medium">Dokumentasi Foto Pelanggan ybs atau penanda tangan KUL / Pimpinan, pada saat penanda tanganan KUL</li>
          </ul>

          <p class="font-9 bold mb-2">Untuk Pelanggan Badan Usaha yang berbentuk Badan Hukum (PT, Koperasi, Yayasan)</p>
          <ul class="mb-4">
            <li class="font-9 medium">Fotokopi KTP Pengurus, NPWP Pelanggan, Nomor Induk Berusaha (NIB), anggaran dasar (Akta Pendirian, Akta Perubahan Pengurus terakhir).</li>
            <li class="font-9 medium">Dokumentasi Foto Pelanggan ybs atau penanda tangan KUL / Pimpinan,pada saat penanda tanganan KUL.</li>
            <li class="font-9 medium">Surat Kuasa jika penandatangan KUL bukanlah pengurus yang sah atau pihak yang berwenang.</li>
            <li class="font-9 medium">Surat pernyataan penanggungan jika ada point No. 8.</li>
          </ul>
          <p class="medium font-9 mb-0">Note : Untuk Customer yang belum memiliki NIB, tetap wajib melampirkan Surat Keterangan Domisili / SITU.</p>
        </div>
      </div>
      <div class="footer"></div>
    </div>
    <div class="page">
      <div class="header">
        <img alt="" class="img-header mb-8" src="{{ imgHeader }}" />
        <div class="space-40"></div>
        <div class="campton font-18 bold text-center mb-2">PAKTA INTEGRITAS</div>
        <div class="campton-medium font-14 medium text-center mb-2">PT MAXXI AGRI INDONESIA</div>
        <div class="space-40"></div>
      </div>
      <div class="body">
        <p class="medium font-10">Kami yang bertandatangan dibawah ini:</p>
        <div class="d-flex">
          <div class="w-20 medium font-10">Nama</div>
          <div class="w-80 medium font-10">: {{ dataKul.owner_name }}</div>
        </div>
        <div class="d-flex">
          <div class="w-20 medium font-10">Jabatan</div>
          <div class="w-80 medium font-10">: Pemilik Usaha</div>
        </div>
        <div class="d-flex mb-4">
          <div class="w-20 medium font-10">Nik</div>
          <div class="w-80 medium font-10">: {{ dataKul.owner_nik }}</div>
        </div>
        <p class="medium font-10">
          Sesuai dengan Anggaran Dasar dan peraturan perusahaan / Pemerintah berwenang <br />
          bertindak untuk dan atas nama :
        </p>
        <div class="d-flex">
          <div class="w-20 medium font-10">Perusahaan</div>
          <div class="w-80 medium font-10">: {{ dataKul.business_name }}</div>
        </div>
        <div class="d-flex">
          <div class="w-20 medium font-10">Alamat</div>
          <div class="w-80 medium font-10">: {{ dataKul.business_address }}</div>
        </div>
        <div class="d-flex mb-4">
          <div class="w-20 medium font-10">Telp</div>
          <div class="w-80 medium font-10">: {{ dataKul.business_phone_number }}</div>
        </div>
        <p class="mb-2 medium font-10">Selaku <b>Distributor</b></p>
        <p class="medium font-10">
          Dalam rangka pelaksanaan kontrak / perjanjian / kesepakatan yang dibuktikan dengan dokumen KUL (Kondisi Untuk Langganan) nomor {{ dataKul.number }} <br />
          dan ditandatangani pada tanggal ............................................................ dengan ini menyatakan bahwa :
        </p>
        <ol>
          <li class="medium font-10">
            Kami atas nama <b>{{ dataKul.business_name }}</b> tidak akan melakukan komunikasi yang mengarah <b>Kolusi, Korupsi, dan Nepotisme</b> dengan Karyawan
            <b>PT Maxxi Agri Indonesia</b> termasuk karyawan atau staff, dari Departemen Marketing meliputi; Direktur, Regional Head, Marketing Executive, Agronomist, dan Spot
            Worker termasuk semua karyawan / staf dari departemen lain, dan <b>{{ dataKul.business_name }} tidak diperbolehkan</b> bekerjasama dalam bentuk apapun termasuk membantu
            menjual atau mendistribusikan produk-produk <b>PT Maxxi Agri Indonesia</b> dikarenakan hal tersebut sudah menjadi kewajiban dan tanggungjawab dari Pihak Kami selaku
            <b>Distributor</b>
          </li>
          <li class="medium font-10">
            Kami selaku distributor berkomitmen untuk melakukan pemesanan produk <b>PT Maxxi Agri Indonesia</b> sesuai dengan kebutuhan dan kemampuan kami dalam memasarkan produk
            tersebut.
          </li>
          <li class="medium font-10">
            Kami selaku Distributor berjanji dan berkomitmen untuk mendukung <b>PT Maxxi Agri Indonesia</b> dalam melaksanakan manajemen perusahaan yang bersifat jujur, transparan
            dan profesional.
          </li>
        </ol>
        <p class="medium font-10">
          Apabila melanggar hal – hal tersebut diatas yang telah kami nyatakan selaku <b>Distributor</b> dalam Pakta Integritas ini, kami siap menghadapi konsekuensi apapun yang
          dianggap baik menurut <b>PT Maxxi Agri Indonesia</b> dan menurut hukum perundang – undangan yang berlaku
        </p>
        <p class="medium font-10">Demikian Pakta Integritas ini dibuat dalam keadaan sadar dan tanpa adanya paksaan dari pihak manapun</p>
        <p class="bold medium font-10">Surabaya,</p>
        <div class="w-30 text-center">
          <div class="space-20"></div>
          <span class="font-8">Materai & Stempel</span>
          <div class="space-20"></div>
          <div class="mb--4 font-10"></div>
          <p class="mb-0 medium font-10">(________________________________)</p>
          <p class="medium font-10">Distributor</p>
        </div>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderTpl><app-fullscreen-loader /></ng-template>
